








import {Annotation} from "@/edinet/annotation/types"
import $ from 'jquery'
import Vue, {PropType} from 'vue'

function scrollToAnnotationId(annotationId: string) {
  const selector = `[data-annotation-id="${annotationId}"]`
  const annotation = $(selector)
  const offset = annotation.offset()
  const ScrollOffset = 50 //cosmetic - add scroll offset so that the annotation shows up in a comfortable position (a bit below the top of the screen)
  if (offset) {
    window.scrollTo(0, offset.top - ScrollOffset)
    return true
  } else {
    console.warn('cannot find element to scroll to: %o', selector)
    return false
  }
}

function scrollToAnnotation(annotation: Annotation, root: Node) {
  // console.log(annotation.serializedRange.start.selector)
  const selector = annotation.serializedRange.start.selector
  const start = $(root).find(selector).offset()
  const ScrollOffset = 50 //cosmetic - add scroll offset so that the annotation shows up in a comfortable position (a bit below the top of the screen)
  if (start) {
    // console.log(start)
    window.scrollTo(0, start.top - ScrollOffset)
  } else {
    console.warn('cannot find node: ' + selector)
  }
}

export default Vue.extend({
  props: {
    annotationRootId: {
      type: String,
      default: 'annotation-root'
    },
    annotation: Object as PropType<Annotation>
  },
  methods: {
    scrollTo: function(annotationId: string) {
      if (!scrollToAnnotationId(annotationId)) {
        //fallback
        console.log('annotationId not found. falling back to using selector...')
        const root = $('#' + this.annotationRootId).get()[0]
        scrollToAnnotation(this.annotation, root)
      }
    }
  }
})

